import { useEffect } from 'react';
import { useAppSelector } from '../state';
import { selectCurrentPath } from '../state/history';
import eventQueue from '../events/queue';
export default function useNavigationListener() {
    var path = useAppSelector(selectCurrentPath);
    useEffect(function () {
        eventQueue.emit('navigation', { historyElement: path });
    }, [path]);
}
